import parseDimensions from "../utils/parseDimensions";
import streamToArray from "../utils/streamToArray";

import getAccessToken from "./getAccessToken";

import type { MetricsRange, MetricsStream } from "../resources/types";

/**
 * Returns a promise that resolves into an array of dimensions already
 * transformed into objects. Empty dimensions will be cleared out.
 */
const getDimensions = async (
  chorusURL: string,
  query: {
    stream: MetricsStream;
    range: MetricsRange;
  }
) => {
  const endpoint = `${chorusURL}/v1/metrics/dimensions`;
  const accessToken = await getAccessToken();

  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken.access_token}`
    },
    body: JSON.stringify(query)
  });

  return streamToArray<{ dimension: string }>(response.body).then(dimensions =>
    dimensions
      .map(({ dimension }) => parseDimensions(dimension))
      .filter(dimension => !!dimension)
  );
};

export default getDimensions;
